<template>
    <div style="padding:10px 15px;background: #fff!important;" class="van-content">
      <van-cell-group  v-html="datas.content">{{datas.content}}</van-cell-group>
  </div>
</template>

<script>

  export default {
    name: "index",
    props:['configData'],
    data () {
      return {
        datas:'',
      }
    },
    methods:{
      goBack: function () {
        history.back(-1);
      },
      getDatas:function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Artice/Index/price', {}, res => {
          this.datas = res.data.data
        })
      },

    },
    mounted () {
      this.getDatas()
    },
  }
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/user/do/zhinan.vue